// removed by extract-text-webpack-plugin
module.exports = {"blackFridayHeader":"qempo_BlackFridayHeader_blackFridayHeader-3ADuQh5","desktopBackground":"qempo_BlackFridayHeader_desktopBackground-24ouqU6","blackFridayTitle":"qempo_BlackFridayHeader_blackFridayTitle-2_CBruh"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/best-deals/components/BlackFridayHeader/BlackFridayHeader.scss
// module id = 2005
// module chunks = 0